export const THREAD_REPLY_CARDS_FEATURE = 'thread_reply_cards'

export function threadReplyCardsEnabled(): boolean {
    return true
}

export function shouldUseThreadReplyCard({
    isActive = false,
    isTitle = false,
}: {
    isActive?: boolean
    isTitle?: boolean
} = {}): boolean {
    return threadReplyCardsEnabled() && isActive && !isTitle
}
